import React from 'react'
import './Title.css';
import MenuBar from './MenuBar';

function Title() {
  return (
    <div className="Title" >
      <h2>గ్రేస్ గాస్పల్ చర్చి ఈదర</h2>
      <MenuBar/>      
    </div>
  )
}

export default Title;